export default {
  title: 'Are you sure you want to logout?',
  buttons: {
    logout: 'Log out',
    cancel: 'Cancel',
  },
};
